import axios from 'axios'
import { env } from '@ivy/fts/envInfo/envInfo'
import { Toast } from 'mint-ui'

env.init()
export async function requireGet(url, params?) {
  const info = await env.getInfo()
  if (env.type === 'web') {
    return Toast('请在App中打开')
  }
  if (env.type === 'ivydad') {
    return axios.get(url, {
      params: {
        ...info.publicParams,
        ...params,
      },
    })
  }
  return axios.get(url, {
    params: {
      ...info.publicParams,
      ...params,
    },
  })
}

export async function requirePost(url, data, config?) {
  const info = await env.getInfo()
  if (env.type === 'web') {
    return Toast('请在App中打开')
  }
  if (env.type === 'ivydad') {
    return axios.post(url, { ...data, ...info.publicParams }, config)
  }
  return axios.post(url, data)
}

// 埋点
/**
 * @param {object} info
 * @param {number} info.activity_id
 * @param {string} info.event_type
 * @param {string} info.method
 * @param {string} info.p1
 * @param {string} info.p2
 * @param {string} info.p3
 * @param {string} info.p4
 * @param {string} info.p5
 * @param {string} info.p6
 */
export async function addStatistics(info, labelType?) {
  if (labelType) {
    let { data } = await requireGet(
      `/api/activity/h5Activity/invitation/getLabelTagName?labelId=${info.p1}`
    )
    info.p1 = data || info.p1
  }
  let requestConfig: any = {
    disableLoading: true,
    disableAlert: true,
    disableNetWorkError: true,
  }

  try {
    await requirePost(
      '/api/activity/h5Activity/invitation/addstatistics',
      {
        ...info,
      },
      requestConfig
    )
  } catch (error) {
    console.log(error)
  }
}
